import React from "react";
import "./PotLabel.scss";
import { AspectRatio } from "../api/ReplayVariables";
import NumberFormat from "react-number-format";

// v2-452: the players' own words, the same in every language of the page
const STREET_NAMES = { PREFLOP: "Preflop", FLOP: "Flop", TURN: "Turn" };

function PotLabel({
  zoneSize,
  realTableRatio,
  action,
  bigBlind,
  bbMode,
  streetPots
}) {
  const cardHeight =
    AspectRatio.refBoardCardWidth *
    realTableRatio *
    AspectRatio.refBoardCardHeightRatio;
  const boardPotMargin = AspectRatio.refBoardPotMargin * realTableRatio;

  const convertToFixed = (inputnum) => {
    var mynum = inputnum.toFixed(2);
    var mynumstr = mynum.toString();
    return parseFloat(mynumstr);
  };

  const nbBB = convertToFixed(action.potSize / bigBlind, 1);

  return (
    <table
      className="pot"
      style={{
        /*
        top: top + "px",
        left: left + "px",
        width: AspectRatio.refPlayerWidth * realTableRatio + "px",
        */
        lineHeight: AspectRatio.refLineHeight * realTableRatio * 2 + "px",
        fontSize: AspectRatio.refFontSize * realTableRatio * 2 + "px",
        // v2-452: the bottom edge on the board and centred by the browser, whatever the size of the label. It was placed
        // from its measured size, and that measure is taken once: the street pots line, which grows street by street
        // and comes and goes with Xeester's menu, left the label off centre, or hanging over the board.
        top: zoneSize.height / 2 - cardHeight / 2 - boardPotMargin + "px",
        transform: "translate(-50%, -100%)"
      }}
    >
      <tbody>
        <tr>
          <td width="50%" align="right">
            &nbsp;POT
          </td>
          <td width="50%" align="left">
            &nbsp;
            <NumberFormat
              value={convertToFixed(bbMode ? nbBB : action.potSize)}
              displayType={"text"}
              thousandSeparator={true}
              renderText={(value) => <>{value}</>}
            />
          </td>
        </tr>
        {/* v2-452: the pot each finished street left, on one line: stacked, three streets would push the pot into
            the seat above, the label being placed from its bottom edge. For the same reason the row stays when it is
            empty, before the flop; it goes only when Xeester's replayer menu hides the street pots. */}
        {streetPots ? (
          <tr>
            <td colSpan="2" align="center" style={{ fontSize: "55%", opacity: 0.75, lineHeight: "100%", whiteSpace: "nowrap" }}>
              {streetPots.length > 0
                ? streetPots.map((street, index) => (
                    <React.Fragment key={street.street}>
                      {index > 0 ? <>&nbsp;&middot; </> : null}
                      {STREET_NAMES[street.street]}&nbsp;
                      <NumberFormat
                        value={convertToFixed(bbMode ? convertToFixed(street.potSize / bigBlind, 1) : street.potSize)}
                        displayType={"text"}
                        thousandSeparator={true}
                        renderText={(value) => <>{value}</>}
                      />
                    </React.Fragment>
                  ))
                : <>&nbsp;</>}
            </td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );
}
export default PotLabel;
